class MediaGallery extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-el="media-gallery.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="media-gallery.slide"]')
    this.controlPrevEl = this.querySelector(
      '[data-el="media-gallery.controlprevious"]'
    )
    this.controlNextEl = this.querySelector(
      '[data-el="media-gallery.controlnext"]'
    )

    if (this.slideEls.length < 2) return

    this.carousel = this.initialiseCarousel()

    this.controlPrevEl.addEventListener('click', this.onNavClick.bind(this))

    this.controlNextEl.addEventListener('click', this.onNavClick.bind(this))
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    return new window.KeenSlider551(this.slidesEl, {
      slides: '.car-Carousel_Slide',
      slidesPerView: 1,
      rubberband: false,
      loop: true,
      created: () => {
        this.slidesEl.classList.remove('car-Carousel_Slides-hidden')
      }
    })
  }

  onNavClick (event) {
    if (event.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

customElements.define('media-gallery', MediaGallery)
